import React, { useEffect, useState } from 'react'

import { BiShapeSquare } from "react-icons/bi";
import { GoPasskeyFill } from "react-icons/go";
import { TbRewindForward50 } from "react-icons/tb";
import { TbRewindBackward50 } from "react-icons/tb";
import { MdCurrencyRupee } from "react-icons/md";
import { MdOutlinePayments } from "react-icons/md";

import heroImg from '../../../../assets/bhutani/Restaurants/restaurantHero.png'
import inner1 from '../../../../assets/bhutani/Restaurants/restaurant-1.jpg'
import inner2 from '../../../../assets/bhutani/Restaurants/restaurant-2.jpg'
import inner3 from '../../../../assets/bhutani/Restaurants/restaurant-3.jpg'
import inner4 from '../../../../assets/bhutani/Restaurants/restaurant-4.jpg'
import inner5 from '../../../../assets/bhutani/Restaurants/restaurant-5.jpg'

import { ImageModal } from '../../../common/ImageModal';
import { ConnectForm } from '../../../common/ConnectForm';

const Restaurants = () => {
    const [openImgModal, setOpenImgModal] = useState(false)
    const innerImgs = [inner1, inner2, inner3, inner4, inner5]





    const points = [
        {
            icon: MdOutlinePayments,
            title: 'Immediate Rent Starts from 50% Payment',
        },
        {
            icon: BiShapeSquare,
            title: 'SIZE - 150 sqft',
        },
        {
            icon: GoPasskeyFill,
            title: 'Leases Guarantee- rs.175 per sqf',
        },
        {
            icon: MdCurrencyRupee,
            title: 'Payment Plan- 50:50',
        },
        {
            icon: TbRewindForward50,
            title: '50% on Booking',
        },
        {
            icon: TbRewindBackward50,
            title: '50% in 18 Months',
        }
    ]

  

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[500px] bg-cover bg-center mb-5"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div class="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify">The Luxury Restaurant at Bhutani City Center 32 in Noida Sector 32 is the epitome of fine dining, offering an exquisite
                                culinary experience that caters to the most discerning of palates. Situated in the heart of Noida, this upscale
                                restaurant combines an elegant ambiance with world-class cuisine to create an unforgettable dining destination.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify"> Upon entering, guests are greeted with sophisticated decor, plush seating, and an atmosphere of refined elegance
                                The interior design seamlessly blends contemporary aesthetics with timeless charm, providing the perfect backdrop
                                for a memorable dining experience.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify"> The restaurant boasts a diverse menu, featuring a curated selection of gourmet dishes prepared by master chefs.
                                From succulent steaks and fresh seafood to authentic regional delicacies and international flavors, every dish is
                                crafted with the finest ingredients and an emphasis on flavor and presentation. Paired with an extensive wine list and
                                artisanal cocktails, the dining experience is elevated to new heights. </p>
                            <p className="text-md text-gray-700 mb-4 text-justify">  Whether you're planning an intimate dinner for two, a family celebration, or a business lunch, the luxury restaurant
                                at Bhutani City Center 32 ensures impeccable service, a tranquil ambiance, and a feast for the senses</p>
                        </div>

                        <div className="max-w-4xl mx-auto p-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {points.map((point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
                                    >
                                        {React.createElement(point.icon, {
                                            size: 24,
                                            color: "green",
                                            className: "w-6 h-6 mr-3",
                                        })}
                                        <span className="text-gray-700 font-medium">{point.title}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            {openImgModal && (
                <ImageModal images={innerImgs} openImg={openImgModal} />
            )}
            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {innerImgs.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => setOpenImgModal(true)}
                        className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                    >
                        <img src={data} alt="Bhutani"
                            className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                        />
                    </div>
                ))}
            </div>

        </div>
    )
}
export default Restaurants;